import SignInForm from "components/modules/auth/SignInForm";
import AuthSimpleLayout from "layouts/AuthSimpleLayout";
import { Alert, Form } from "react-bootstrap";
import { Navigate, useSearchParams } from "react-router-dom";
import { useLogin } from "services/account";

const SignIn = () => {
  const [searchParams] = useSearchParams();
  const { mutateAsync, isSuccess, isPending, error } = useLogin();

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await mutateAsync({
      email: e.currentTarget.email.value,
      senha: e.currentTarget.password.value,
      lembrarMe: e.currentTarget.remember.checked,
    });
  };

  // if (data?.data?.status === 2) {
  //   console.log(data);
  //   setNewPassword(data.data.email, data.data.session);
  //   return (
  //     <Navigate
  //       to="/pages/authentication/simple/reset-password"
  //       replace
  //       state={{
  //         email: data.data.email,
  //         session: data.data.session,
  //       }}
  //     />
  //   );
  // }

  // if (data?.data?.status === 1) {
  //   return (
  //     <Navigate
  //       to="/pages/authentication/simple/2FA"
  //       replace
  //       state={{ email: data.data.email, recovery: false }}
  //     />
  //   );
  // }

  if (isSuccess) {
    const from = searchParams.get("from");

    return <Navigate to={from || "/"} replace />;
  }

  return (
    <AuthSimpleLayout>
      <Form onSubmit={handleLogin}>
        <SignInForm layout="simple" loading={isPending} />
        {error && (
          <Alert variant={"phoenix-danger"} className="mt-4">
            {error?.response?.data?.mensagem || "Ocorreu um erro inesperado."}
          </Alert>
        )}
      </Form>
    </AuthSimpleLayout>
  );
};

export default SignIn;
